import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import HeaderBackground from "../../../common/SubpagesBGimage";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import { StatutoryCommitteeActions } from "../../../Store/Statutory Committee/action";
import Template1 from "./Template1";
import Template2 from "./Template2"; 

function Detailpage() {
  const location = useLocation();
  const { committeeSlug } = useParams();
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);

  const routeNames = {
    "/statutory-committee": {
      menuName: "About Us",
      subMenuName: "Statutory Committee",
    },
  };

  const slugify = (text) => text?.toLowerCase().replace(/\s+/g, "-");

  const { menuName = "About Us", subMenuName = "Statutory Committee" } =
    location.state || routeNames[location.pathname] || {};

  const { StatutoryCommitteeSubpage } = useSelector(
    (state) => state?.StatutoryCommitteeReducer
  );

 useEffect(() => {
  if (!StatutoryCommitteeSubpage?.length) {
    dispatch({
      type: StatutoryCommitteeActions.GET_STATUTORY_COMMITTEE_SUBPAGE,
    });
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


  const selectedCommittee = StatutoryCommitteeSubpage?.find(
    (committee) => slugify(committee.committee_name) === committeeSlug
  );

  if (!selectedCommittee) {
    return (
      <div className="spinner-container-admission">
        <div className="spinner-admission"></div>
      </div>
    );
  }

  // Determine template type from API
  const mapName = selectedCommittee?.map_name?.toLowerCase();

  //  Select which template to render
  const renderTemplate = () => {
    switch (mapName) {
      case "template_1":
        return <Template1 selectedCommittee={selectedCommittee} />;
      case "template_2":
        return <Template2 selectedCommittee={selectedCommittee} />;
      default:
        return (
          <div className="container py-4 mb-5">
            <h6 className="rectangle-title mb-0 me-3 position-relative">
              <span className="rectangle-marker me-2"></span>
              {selectedCommittee?.committee_name}
            </h6>

            {/* Render HTML content from backend */}
            <div
              className="committee-content mt-4 rect-text rect-bullet"
              dangerouslySetInnerHTML={{
                __html: selectedCommittee?.content,
              }}
            />

            {/* Optional PDF display */}
            {selectedCommittee?.pdf && (
              <div className="text-center mt-4">
                <img
                  src={selectedCommittee?.pdf}
                  alt="Committee PDF"
                  className="img-fluid rounded shadow"
                />
              </div>
            )}
          </div>
        );
    }
  };

  return (
    <div>
      <HeaderBackground
        menuName={menuName}
        subMenuName={subMenuName}
        thirdLevelName={selectedCommittee?.committee_name}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />

      {/*  Dynamic render based on map_name */}
      {renderTemplate()}

      <SideNavigation
        key={menuName}
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        openKeys={openKeys}
        onOpenChange={(keys) => setOpenKeys(keys)}
        defaultOpenSubMenu={menuName}
      />
    </div>
  );
}

export default Detailpage;
